import React from 'react'
import BannerUpdate from '../banner_components/banner_update'

export default function Main() {
  return (
    <div className='content-wrapper bg-white p-5' style={{ marginLeft: 0 }}>
      <div>
        <h2>Update Banner</h2>
        <BannerUpdate />
      </div>
    </div>
  )
}
